import ReactDOM from 'react-dom/client';
import { v2Component } from '../../../index';
import { TenantContext } from '../../../context/tenant-context';
import { ToastContainer } from 'react-toastify';
import { UnpaidBatchConfig } from './unpaid-batch';

export function initUnpaidBatch(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('unpaid-email-payment-notification');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        const props = {
          ...dataset,
        };

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <UnpaidBatchConfig {...props} />
            </TenantContext.Provider>,
          ),
        );
      };
      bootstrap();
    }
  });
}
